import template from './history.html'

export let history = {
	template    : template,
	controllerAs: 'vm',
	controller  : [ '$rootScope', '$cookies', 'ReviewSrv', 'GlobalConfig', 'CssClasses', 'Validations', 'Setters',
		'Requests', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', '$mdDialog', '$state', '$scope', '$sessionStorage', '$mdToast',
		function historyCtrl ($rootScope, $cookies, ReviewSrv, GlobalConfig, CssClasses, Validations, Setters, Requests, WorkPlanSrv, WorkPlanModalSrv, $stateParams, $mdDialog, $state, $scope, $sessionStorage, $mdToast) {
			// constants
			const _modulesNames = GlobalConfig.modulesNames // GlobalConfig.modulesOrderTab
			const _modulesIds = GlobalConfig.modules
			const user = JSON.parse($cookies.get('currentUser'))
			const roleId = +$cookies.get('hasRoleId')

			const getWorkplans = Requests.getWorkplans(ReviewSrv)
			const getReviewList = Requests.getReviewList()

			const formatActivity = Setters.formatActivity(Setters.setTagName(Validations))
			const setEndExecutionHeader = Requests.setEndExecutionHeader(GlobalConfig)

			const setDetailsHeader = Requests.setDetailsHeader(Validations)
			const getActivityDetails = Requests.getActivityDetails(ReviewSrv, setDetailsHeader)
			const getSummanyProgress = Requests.getSummanyProgress(WorkPlanSrv)

			// variables
			let _currentModule = GlobalConfig.modules.teaching

			let _label = GlobalConfig.modulesNames.teaching

			var _status = false

			if ($sessionStorage.workPlanGeneralList != undefined) {
				var _workPlanGeneralList = $sessionStorage.workPlanGeneralList

				_status = _workPlanGeneralList.wokplanTeacherStatus[0]
			}

			let _workplans = []
			let _selectedWorkplan = null
			let _selectedActivity = {}
			let _isFeedback = 0
			let _stageId = 0
			let itemList = []
			let iconClasses = [
				'mdi-hardware-keyboard-arrow-down',
				'mdi-hardware-keyboard-arrow-up',
			]
			let post = {
				workplanId: JSON.parse($cookies.get('currentUser')).workplanId || $stateParams.workplanId,
				teacherId : JSON.parse($cookies.get('currentUser')).teacherId,
			}

			const normalizeActivity = Requests.normalizeActivity(Requests.setNullHours)
			const formatSubjectActivity = Requests.formatSubjectActivity(normalizeActivity)
			const routeDetails = Requests.routeDetails(Validations, Requests.setNullHours, Requests.setStudentAttentionData, formatSubjectActivity)

			const safeText = (v) => (v == null ? '' : v)
			const safeNum = (v) => (v == null ? 0 : v)

			$scope.module = ''

			angular.extend(this, {
				// variables
				get modules () {
					return _modulesNames
				},
				get modulesIds () {
					return _modulesIds
				},
				get inModule () {
					return _currentModule
				},
				set inModule (value) {
					_currentModule = value

					return value
				},
				get currentLabel () {
					return _label
				},
				set currentLabel (value) {
					_label = value

					return value
				},
				get workplans () {
					return _workplans
				},
				set workplans (value) {
					_workplans = value

					return value
				},
				get selectedWorkplan () {
					return _selectedWorkplan
				},
				set selectedWorkplan (value) {
					_selectedWorkplan = value

					return value
				},
				get selectedActivity () {
					return _selectedActivity
				},
				set selectedActivity (value) {
					_selectedActivity = value

					return value
				},
				keys            : [],
				activities      : [],
				details         : null,
				filter          : '',
				isLoadingDetails: false,
				loadDetails     : loadDetails,
				selectedTab     : null,
				planningFinish  : 1,
				executionFinish : 1,
				currentStage    : $stateParams.stage,
				stageName       : GlobalConfig.workplanStagesNames.planning,
				recordTeacher   : [],
				showTable       : true,
				inHistory       : true,
				iconClasses     : [
					'mdi-hardware-keyboard-arrow-down',
					'mdi-hardware-keyboard-arrow-up',
				],
				class       : iconClasses[1],
				title       : null,
				// methods
				updateFilter: (val) => {
					this.filter = val
				},

				loadListData               : loadListData,
				thereIsDetails             : thereIsDetails,
				endPlanning                : endPlanning,
				isButtonDisabled           : isButtonDisabled,
				showFinishButton           : true,
				hiddenTable                : hiddenTable,
				endStage                   : endStage,
				downloadPdf                : downloadPdf,
				pdfReporthistoricalWorkplan: pdfReporthistoricalWorkplan,
				prepareInformation         : prepareInformation,
				clean                      : (module) => {
					this.activities = []
					this.details = null
					this.loadListData(this.selectedWorkplan, 1, module)
				},

			})

			this.$onInit = () => {
				this.downloadRequests = 0

				if (roleId === GlobalConfig.userRolesIds.workPlanAdmin ||
			roleId === GlobalConfig.userRolesIds.unitAdmin ||
			roleId === GlobalConfig.userRolesIds.gerencialConsultant) {
					this.showFinishButton = false
				}

				if ($cookies.get('isReproved') && JSON.parse($cookies.get('isReproved')) && roleId != GlobalConfig.userRolesIds.workplanCommittee) {
					showModalReactivateWorkplan(this)
				} else {
					getData(this)
				}
			}

			function getData(obj) {
				//Se setean las variables a utilizar para la vista de Planes Trabajos (Resumen/Historial)
				if ($stateParams.currentStage) {
					obj.currentStage = $stateParams.currentStage
					post.workplanId = $stateParams.workplanId
					post.teacherId = $stateParams.teacherId
					user.teacherId = $stateParams.teacherId
					user.workplanId = $stateParams.workplanId
				}

				if ($stateParams.teacherId)
					user.teacherId = $stateParams.teacherId

				obj.stageName = obj.currentStage !== 'planning' ? GlobalConfig.workplanStagesNames.execution : obj.stageName
				obj.keys = Object.keys(obj.modules)
				obj.keys.splice(5, 1)
				let previousState = Reflect.has($rootScope, 'previousState') ? $rootScope.previousState : {}
				let module = Reflect.has(previousState, 'moduleId') ? previousState.moduleId : false

				getRecordTeacher(post, obj)
				let modsArr = [
					_modulesIds.teaching,
					_modulesIds.investigation,
					_modulesIds.extentionAndVisibility,
					_modulesIds.academicManagement,
					_modulesIds.consolidation,
				]

				obj.modsArr = modsArr
				obj.selectedTab = module ? modsArr.indexOf(module) : 0
				getWorkplans(user).then(data => {
					obj.workplans = data
					obj.selectedWorkplan = obj.workplans[0].workplanId
					previousState ? obj.loadListData(obj.selectedWorkplan, obj.keys[obj.selectedTab]) : obj.loadListData(obj.selectedWorkplan)
				})
			}
			// LOAD LIST DATA

			function setModule (obj, module) {
				if (module) {
					return module
				}

				return obj.keys[obj.inModule - 2]
			}

			function showToast(message, isError) {
				$mdToast.show(
					$mdToast.simple()
						.textContent(message)
						.position('bottom right')
						.hideDelay(isError ? 5000 : 3000)
						.toastClass(isError ? 'toast-error' : 'toast-info'),
				)
			}

			function downloadPdf(workplan) {
				showToast('Se inició la descarga del reporte', false)
				this.result = []
				this.selectWorkPlan = this.workplans.find(e => {
					return e.workplanId === this.recordTeacher.workplanId
				})
				/*
console.log('--------------------------------------------------')
console.log('this.selectWorkPlan => ', this.selectWorkPlan)
console.log('--------------------------------------------------')
*/
				const promises = this.keys.map(e => {
					return getReviewList(user.teacherId, workplan, ReviewSrv, workplan, e).then((data) => {
						if (e !== 'teaching') {
							return data
						}

						const promises = data.map((activity) => {
							//load details
							return getActivityDetails(e, activity).then((details) => {
								let detailsData = routeDetails(e, activity, details)
	
								if (detailsData.data) {
									detailsData.data.totalExecutedHours = detailsData.children ? calcHours(detailsData.children, 'hoursExecuted') : 0
									detailsData.data.totalPlannedHours = detailsData.children ? calcHours(detailsData.children, 'hoursPlanned') : 0
									activity.details = detailsData
								} else {
									activity.details = null
								}
							})
						})
	
						return Promise.all(promises).then(() => data)
					}).then((data) => {
						data.push(this.modules[e])
						this.result.push(data)
					})
				})

				Promise.all(promises).then(() => {
					this.prepareInformation()
				}).catch((error) => {
					console.log(error)
					showToast('Error al generar el reporte', true)
				})
			}

			function prepareInformation() {
				try {
					this.data = []
					this.summary = []

					this.result.forEach(tipo => {
						switch (tipo[tipo.length - 1]) {

						case 'Docencia':
							let docenciaArray = []

							this.summary[tipo[tipo.length - 1]] = {
								planning: 0,
								executed: 0,
							}

							let nonAsignatureArray = [
								{
									table: {
										widths: [ 'auto', 'auto', 'auto', 'auto', 'auto' ],
										body  : [
											[ { text: 'Docencia - Otras Actividades de Docencia', colSpan: 5, alignment: 'center', bold: true }, '', '', '', '' ],
											[ { text: 'Actividad', alignment: 'center', bold: true }, { text: 'Tipo', alignment: 'center', bold: true }, { text: 'Detalle', alignment: 'center', bold: true }, { text: 'Planeación', alignment: 'center', bold: true }, { text: 'Ejecución', alignment: 'center', bold: true } ],
										],
									},
								},
							]

							let asignatureArray = [ 
								{
									table: {
										widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ],
										body  : [
											[ { text: 'Docencia - Asignatura a Cargo', colSpan: 10, alignment: 'center', bold: true }, '', '', '', '', '', '', '', '', '' ],
											[ { text: 'Periodo', rowSpan: 2, alignment: 'center', bold: true }, { text: 'Nombre', rowSpan: 2, alignment: 'center', bold: true }, { text: 'Nivel', rowSpan: 2, alignment: 'center', bold: true }, { text: 'Tipo', rowSpan: 2, alignment: 'center', bold: true }, 
												{ text: 'Modalidad', rowSpan: 2, alignment: 'center', bold: true }, { text: 'Nro de grupos', rowSpan: 2, alignment: 'center', bold: true }, { text: 'Planeación', colSpan: 2, alignment: 'center', bold: true }, '', { text: 'Ejecución', colSpan: 2, alignment: 'center', bold: true }, '' ],
											[ '', '', '', '', '', '', { text: 'Horas directa', alignment: 'center', bold: true }, { text: 'Horas indirecta', alignment: 'center', bold: true }, { text: 'Horas directa', alignment: 'center', bold: true }, { text: 'Horas indirecta', alignment: 'center', bold: true } ],
			
										],
										dontBreakRows: true,
									},
								},
								{
									text : '\n',
									style: 'anotherStyle',
								},
							]

							tipo.forEach((dato, index) => {
								if (tipo.length - 1 > index) {
									this.summary[tipo[tipo.length - 1]].planning = this.summary[tipo[tipo.length - 1]].planning + safeNum(dato.totalHoursPlanned)
									this.summary[tipo[tipo.length - 1]].executed = this.summary[tipo[tipo.length - 1]].executed + safeNum(dato.totalHoursExecuted)

									const detailsData = (dato.details && dato.details.data) ? dato.details.data : {}
									const detailsPlanning = (dato.details && dato.details.planning) ? dato.details.planning : []
									const detailsTeaching = (dato.details && dato.details.teaching) ? dato.details.teaching : []

									if (dato.asignatureName == undefined) {
										nonAsignatureArray[0].table.body.push(
											[
												{ text: safeText(dato.activityTypeName) },
												{ text: safeText(dato.scheduleTypeName ? dato.scheduleTypeName : dato.activityTypeNameCombo) },
												{ text: safeText(detailsData.daysNames ? detailsData.daysNames : dato.description) },
												{ text: safeNum(dato.totalHoursPlanned) },
												{ text: safeNum(dato.totalHoursExecuted) },
											],
										)
									} else {
										asignatureArray[0].table.body.push(
											[
												{ text: safeText(dato.periodicityName), alignment: 'center' },
												{ text: safeText(dato.asignatureName), alignment: 'center' },
												{ text: safeText(dato.asignatureLevel), alignment: 'center' },
												{ text: safeText(dato.asignatureType), alignment: 'center' },
												{ text: safeText(dato.asignatureModality), alignment: 'center' },
												{ text: safeNum(dato.groupsTempNum), alignment: 'center' },
												{ text: safeNum(detailsData.hoursPlanned), alignment: 'center' },
												{ text: safeNum(detailsPlanning['totalPlannedHours']) + safeNum(detailsTeaching['totalPlannedHours']), alignment: 'center' },
												{ text: safeNum(detailsData.hoursExecuted), alignment: 'center' },
												{ text: safeNum(detailsPlanning['totalExecutedHours']) + safeNum(detailsTeaching['totalExecutedHours']), alignment: 'center' },
											],
										)
										let asignature = {
											table: {
												widths: [ 120, 120, 120, 120 ],
												body  : [
													[ { text: safeText(dato.asignatureName) + ' ' + safeText(dato.periodicityName), colSpan: 4, alignment: 'center', bold: true }, '', '', '' ],
													[ { text: 'Actividad', alignment: 'center', bold: true }, { text: 'Detalle', alignment: 'center', bold: true }, { text: 'Planeación', alignment: 'center', bold: true }, { text: 'Ejecución', alignment: 'center', bold: true } ],
												],

											},
										}

										if (detailsPlanning.length > 0) {
											detailsPlanning.forEach((item, index) => {
												asignature.table.body.push([
													{ text: 'Planeación y Gestión', rowSpan: index == 0 ? detailsPlanning.length : 1, alignment: 'center', bold: true },
													{ text: safeText(item.name), alignment: 'center' },
													{ text: safeNum(item.hoursPlanned), alignment: 'center' },
													{ text: safeNum(item.hoursExecuted), alignment: 'center' },
												])
											})
										} else {
											asignature.table.body.push([
												{ text: 'Planeación y Gestión', alignment: 'center', bold: true },
												{ text: '', alignment: 'center' },
												{ text: 0, alignment: 'center' },
												{ text: 0, alignment: 'center' },
											])
										}

										if (detailsTeaching.length > 0) {
											detailsTeaching.forEach((item, index) => {
												asignature.table.body.push([
													{ text: 'Formación Jóvenes Docentes', rowSpan: index == 0 ? detailsTeaching.length : 1, alignment: 'center', bold: true },
													{ text: safeText(item.name), alignment: 'center' },
													{ text: safeNum(item.hoursPlanned), alignment: 'center' },
													{ text: safeNum(item.hoursExecuted), alignment: 'center' },
												])
											})
										} else {
											asignature.table.body.push([
												{ text: 'Formación Jóvenes Docentes', alignment: 'center', bold: true },
												{ text: '', alignment: 'center' },
												{ text: 0, alignment: 'center' },
												{ text: 0, alignment: 'center' },
											])
										}

										asignatureArray.push(asignature)
										asignatureArray.push({
											text : '\n',
											style: 'anotherStyle',
										})
									}
								}
							})
							docenciaArray.push(asignatureArray)
							docenciaArray.push(nonAsignatureArray)
						
							this.data[tipo[tipo.length - 1]] = docenciaArray
							break
						case 'Investigación e innovación':
							let investigacionArray = []

							this.summary[tipo[tipo.length - 1]] = {
								planning: 0,
								executed: 0,
							}

							investigacionArray.push(//[ { text: tipo[tipo.length - 1], style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {} ],
								[ { text: 'Periodo', fontSize: 10, bold: true },
									{ text: 'Subactividad', fontSize: 10, bold: true },
									{ text: 'Actividad', fontSize: 10, bold: true },
									{ text: 'Descripción', fontSize: 10, bold: true },
									{ text: 'Total hrs planeadas', fontSize: 10, bold: true },
									{ text: 'Total hrs ejecutadas', fontSize: 10, bold: true } ])
							tipo.forEach((dato, index) => {
								if (tipo.length - 1 > index) {
									this.summary[tipo[tipo.length - 1]].planning = this.summary[tipo[tipo.length - 1]].planning + safeNum(dato.totalHoursPlanned)
									this.summary[tipo[tipo.length - 1]].executed = this.summary[tipo[tipo.length - 1]].executed + safeNum(dato.totalHoursExecuted)

									investigacionArray.push([
										{ text: safeText(dato.periodicityName) },
										{ text: safeText(dato.activityTypeName) },
										{ text: safeText(dato.name) },
										{ text: safeText(dato.description) },
										{ text: safeNum(dato.totalHoursPlanned) },
										{ text: safeNum(dato.totalHoursExecuted) } ])
								}
							})
							this.data[tipo[tipo.length - 1]] = investigacionArray
							break
						case 'Extensión y visibilidad':
							let extensionArray = []

							this.summary[tipo[tipo.length - 1]] = {
								planning: 0,
								executed: 0,
							}

							extensionArray.push(//[ { text: tipo[tipo.length - 1], style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {} ],
								[ { text: 'Periodo', fontSize: 10, bold: true },
									{ text: 'Subactividad', fontSize: 10, bold: true },
									{ text: 'Actividad', fontSize: 10, bold: true },
									{ text: 'Descripción', fontSize: 10, bold: true },
									{ text: 'Total hrs planeadas', fontSize: 10, bold: true },
									{ text: 'Total hrs ejecutadas', fontSize: 10, bold: true } ])
							tipo.forEach((dato, index) => {
								if (tipo.length - 1 > index) {
									this.summary[tipo[tipo.length - 1]].planning = this.summary[tipo[tipo.length - 1]].planning + safeNum(dato.totalHoursPlanned)
									this.summary[tipo[tipo.length - 1]].executed = this.summary[tipo[tipo.length - 1]].executed + safeNum(dato.totalHoursExecuted)
									extensionArray.push([
										{ text: safeText(dato.periodicityName) },
										{ text: safeText(dato.activityTypeName) },
										{ text: safeText(dato.name) },
										{ text: safeText(dato.description) },
										{ text: safeNum(dato.totalHoursPlanned) },
										{ text: safeNum(dato.totalHoursExecuted) } ])
								}
							})
							this.data[tipo[tipo.length - 1]] = extensionArray
							break
						case 'Gestión académica':
							let gestionArray = []

							this.summary[tipo[tipo.length - 1]] = {
								planning: 0,
								executed: 0,
							}

							gestionArray.push(//[ { text: tipo[tipo.length - 1], style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {} ],
								[ { text: 'Periodo', fontSize: 10, bold: true },
									{ text: 'Subactividad', fontSize: 10, bold: true },
									{ text: 'Actividad', fontSize: 10, bold: true },
									{ text: 'Descripción', fontSize: 10, bold: true },
									{ text: 'Total hrs planeadas', fontSize: 10, bold: true },
									{ text: 'Total hrs ejecutadas', fontSize: 10, bold: true } ])
							tipo.forEach((dato, index) => {
								if (tipo.length - 1 > index) {
									this.summary[tipo[tipo.length - 1]].planning = this.summary[tipo[tipo.length - 1]].planning + safeNum(dato.totalHoursPlanned)
									this.summary[tipo[tipo.length - 1]].executed = this.summary[tipo[tipo.length - 1]].executed + safeNum(dato.totalHoursExecuted)
									let name = dato.academicUnitName == null ? (dato.otherActivityItemName == null ? dato.activityTypeName : dato.otherActivityItemName) : dato.academicUnitName

									gestionArray.push([
										{ text: safeText(dato.periodicityName) },
										{ text: safeText(dato.activityTypeName) },
										{ text: safeText(name) },
										{ text: safeText(dato.description) },
										{ text: safeNum(dato.totalHoursPlanned) },
										{ text: safeNum(dato.totalHoursExecuted) } ])
								}
							})
							this.data[tipo[tipo.length - 1]] = gestionArray
							break
						case 'Consolidación de cuerpo profesoral':
							let consolidacionArray = []

							this.summary[tipo[tipo.length - 1]] = {
								planning: 0,
								executed: 0,
							}

							consolidacionArray.push(//[ { text: tipo[tipo.length - 1], style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {} ],
								[ { text: 'Periodo', fontSize: 10, bold: true },
									{ text: 'Subactividad', fontSize: 10, bold: true },
									{ text: 'Actividad', fontSize: 10, bold: true },
									{ text: 'Descripción', fontSize: 10, bold: true },
									{ text: 'Total hrs planeadas', fontSize: 10, bold: true },
									{ text: 'Total hrs ejecutadas', fontSize: 10, bold: true } ])
							tipo.forEach((dato, index) => {
								if (tipo.length - 1 > index) {
									this.summary[tipo[tipo.length - 1]].planning = this.summary[tipo[tipo.length - 1]].planning + safeNum(dato.totalHoursPlanned)
									this.summary[tipo[tipo.length - 1]].executed = this.summary[tipo[tipo.length - 1]].executed + safeNum(dato.totalHoursExecuted)
									consolidacionArray.push([
										{ text: safeText(dato.periodicityName) },
										{ text: safeText(dato.activityTypeName) },
										{ text: safeText(dato.name) },
										{ text: safeText(dato.description) },
										{ text: safeNum(dato.totalHoursPlanned) },
										{ text: safeNum(dato.totalHoursExecuted) } ])
								}
							})
							this.data[tipo[tipo.length - 1]] = consolidacionArray
							break

						}
					})
					this.keys.forEach(tipo => {
						if (this.summary[this.modules[tipo]]) {
							this.summary['totalPlanned'] = (this.summary['totalPlanned'] ? this.summary['totalPlanned'] : 0) + this.summary[this.modules[tipo]].planning
							this.summary['totalExecuted'] = (this.summary['totalExecuted'] ? this.summary['totalExecuted'] : 0) + this.summary[this.modules[tipo]].executed
						}
					})
				
					this.pdfReporthistoricalWorkplan()
				} catch (error) {
					console.log(error)
					showToast('Error al generar el reporte', true)
				}
			}

			function pdfReporthistoricalWorkplan() {
				var fonts = {
					Roboto: {
						normal     : 'fonts/Roboto-Regular.ttf',
						bold       : 'fonts/Roboto-Medium.ttf',
						italics    : 'fonts/Roboto-Italic.ttf',
						bolditalics: 'fonts/Roboto-MediumItalic.ttf',
					},
				}

				//var testImageDataUrl = require('../images/hat.png');
				/*
				console.log('--------------------------------------------------')
				console.log('LLEGO A PDF');
				console.log('--------------------------------------------------')
				*/
				
				const recordTeacher = this.recordTeacher || {}
				const selectWorkPlan = this.selectWorkPlan || {}

				this.content = [
					{ text: 'Reporte Plan de trabajo Histórico', style: 'header', bold: true, alignment: 'center', fontSize: 22 },
					{ text: '\n', style: 'anotherStyle' },
					{
						table: {
							widths: [ 160, 339 ],
							body  : [
								[ 'Profesor', safeText(user.dsFullname) ],
								[ 'Unidad Académica', safeText(recordTeacher.academicName) ],
								[ 'Plan de trabajo', safeText(selectWorkPlan.workplanName) ],
								[ 'Etapa', safeText(recordTeacher.currentStageName) ],
								[ 'Revisores', safeText(recordTeacher.revieweds) ],
								[ 'Evaluador Principal', safeText(recordTeacher.evaluators) ],
								[ 'Resultado de la evaluación', safeText(recordTeacher.criteriaEvaluation) ],
								[ 'Observaciones de la evaluación', safeText(recordTeacher.dateEndEvaluation) ],
							],
							dontBreakRows: true,
						},
					},
					{
						text : '\n',
						style: 'anotherStyle',
					},
				]
				let summaryTable = {
					table: {
						widths: [ 132, 85, 85, 85, 85 ],
						body  : [
							[ { rowSpan: 2, text: 'Actividad', bold: true, alignment: 'center' }, { colSpan: 2, text: 'Planeación', bold: true, alignment: 'center' }, '', { colSpan: 2, text: 'Ejecución', bold: true, alignment: 'center' }, '' ],
							[ '', { text: 'Horas', bold: true, alignment: 'center' }, { text: 'Porcentaje', bold: true, alignment: 'center' }, { text: 'Horas', bold: true, alignment: 'center' }, { text: 'Porcentaje', bold: true, alignment: 'center' } ],

						],
						dontBreakRows: true,
					},
				}

				this.keys.forEach(tipo => {
					let info = this.summary[this.modules[tipo]] ? this.summary[this.modules[tipo]] : { planning: 0, executed: 0 }
					const totalPlanned = safeNum(this.summary['totalPlanned'])
					const totalExecuted = safeNum(this.summary['totalExecuted'])

					summaryTable.table.body.push([
						safeText(this.modules[tipo]),
						safeNum(info.planning),
						(totalPlanned > 0 ? (safeNum(info.planning) * 100 / totalPlanned).toFixed(2) + '%' : '-'),
						safeNum(info.executed),
						(totalExecuted > 0 ? (safeNum(info.executed) * 100 / totalExecuted).toFixed(2) + '%' : '-'),
					])
				})
				summaryTable.table.body.push([
					{ text: 'Total', alignment: 'center', bold: true },
					{ text: safeNum(this.summary['totalPlanned']), fontSize: 10 },
					{ text: (safeNum(this.summary['totalPlanned']) > 0 ? 100 + '%' : '-'), fontSize: 10 },
					{ text: safeNum(this.summary['totalExecuted']), fontSize: 10 },
					{ text: (safeNum(this.summary['totalExecuted']) > 0 ? 100 + '%' : '-'), fontSize: 10 },
				])

				this.content.push(summaryTable)
				this.content.push({
					text : '\n',
					style: 'anotherStyle',
				})
				
				this.keys.forEach(tipo => {
					let info = this.data[this.modules[tipo]]
					var tableWidths = []

					if (this.modules[tipo] === 'Docencia') {
						this.content.push(this.data[this.modules[tipo]])
					} else {
						tableWidths = [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ]

						if (info && info.length > 1) {
							this.content.push({
								text : '\n',
								style: 'anotherStyle',
							}, 
							{ text: this.modules[tipo], alignment: 'center', fontSize: 14, bold: true },
							{
								table: {
									widths       : tableWidths,
									body         : this.data[this.modules[tipo]],
									dontBreakRows: true,
								},
							})
						}
					}
				})

				var docDefinition = {
					content     : this.content,
					defaultStyle: {
						fontSize: 8,
					},
				}

				pdfMake.createPdf(docDefinition).download('report.pdf')
			}

			function loadListData (workplan, param, module = false) {
				let modu = (module) ? module : param
				let mod = (param == 2) ? $scope.module : setModule(this, modu)

				$scope.module = mod

				if (true) {
					this.inModule = this.modulesIds[mod]
					this.currentLabel = this.modules[mod]
					post = {
						teacherId : user.teacherId,
						workplanId: workplan,
					}

					getRecordTeacher(post, this)
					/*
					console.log('--------------------------------------------------')
					console.log('user.teacherId => ', user.teacherId)
					console.log('workplan => ', workplan)
					console.log('ReviewSrv => ', ReviewSrv)
					console.log('mod => ', mod)
					console.log('--------------------------------------------------')
					*/
					getReviewList(user.teacherId, workplan, ReviewSrv, workplan, mod).then((data) => {
						getGeneralsWorkplan().then((response) => {
							$cookies.put('workplan-approvedFinish', response.approvedFinish)
							$cookies.put('workplan-executionFinish', response.executionFinish)
							_isFeedback = (response.isState == 1 ? response.feedbackReviewed : 1)
							this.planningFinish = ((response.isState == 1 && response.planningFinish == 0) ? false : true)
							this.executionFinish = ((response.isState == 1 && response.executionFinish == 0) ? false : true)
							_stageId = response.stageId
							this.activities = formatActivity(data, _stageId, Validations) // sortActivitiesList(formatActivity(data, _stageId, Validations))
							this.loadDetails(this.activities[0], mod)
						})
					})
					$scope.Mod = mod
				}
			}

			function calcHours(arr, param) {
				return arr.reduce((accumulator, current) => (accumulator + current[param]), 0)
			}

			function loadDetails (activity, module) {
				let mod = setModule(this, module)

				this.selectedActivity = activity
				this.isLoadingDetails = true
				this.details = null
				this.notPlanned = false

				if (activity && !activity.workplanTeacherActivityId) {
					this.notPlanned = true
					this.isLoadingDetails = false
				} else if (activity) {
					getActivityDetails(mod, activity).then((data) => {
						if (!data) {
							this.isLoadingDetails = false
							this.details = null

							return
						}

						this.details = routeDetails(mod, activity, data)
						this.details.data.isFeedbackReviewed = Boolean(_isFeedback && !this.planningFinish)
						this.details.data.stageId = _stageId

						if (this.details.data) {
							this.details.data.totalExecutedHours = this.details.children ? calcHours(this.details.children, 'hoursExecuted') : 0
							this.details.data.totalPlannedHours = this.details.children ? calcHours(this.details.children, 'hoursPlanned') : 0
						}

						this.details.data ? this.isLoadingDetails = false : this.details = null
					})
				} else {
					this.details = null
					this.isLoadingDetails = false
				}
			}

			function thereIsDetails () {
				return Boolean(this.details)
			}

			function getGeneralsWorkplan () {
				return ReviewSrv.getWorkPlanGeneralDetail.get({ teacherId: user.teacherId }).$promise.then((dataReturn) => dataReturn.status ? dataReturn.data.wokplanTeacherStatus[0] : null)
			}

			function endPlanning (wpId) {
				let post = {
					teacherId         : user.teacherId,
					workplanId        : wpId,
					userId            : user.id,
					stageId           : GlobalConfig.workplanIdStages.planning,
					stageName         : GlobalConfig.workplanStagesNames.planning,
					submodules        : JSON.parse($cookies.get('subModuleId')),
					teaching          : GlobalConfig.modules.teaching,
					academicManagement: GlobalConfig.modules.academicManagement,
					feedback          : _isFeedback,
				}
				let submodules = Requests.submoduleItemRequired(post)

				if (submodules.teaching || submodules.academicManagement) {
					return Requests.getItemsRequiredList(WorkPlanSrv, post).then((data) => {
						data.submodule = submodules

						if (Requests.validateItems(data)) {
							Requests.showModalItemRequiredEndPlanning(WorkPlanModalSrv, data)

							return 0
						} else {
							return Requests.showModalEndPlannig(WorkPlanSrv, WorkPlanModalSrv, post, $mdDialog)
								.then((result) => {
									// return result
								})
						}
					})
				} else {
					return Requests.showModalEndPlannig(WorkPlanSrv, WorkPlanModalSrv, post, $mdDialog).then((result) => {
						// return result
					})
				}
			}

			function isButtonDisabled () {
				if (_status.workplanActive) {
					const curdate = moment()
					const endPlannigDate = moment(this.recordTeacher.dateEndPlanning, 'DD/MM/YYYY')

					return this.currentStage === 'planning' ? (this.planningFinish || curdate > endPlannigDate) : this.executionFinish
				} else {
					return true
				}
			}

			function endStage () {
				this.planningFinish = 1
				this.executionFinish = 1

				if (this.currentStage === 'planning') {
					endPlanning(this.selectedWorkplan).then((result) => {
						this.planningFinish = result
					})
				} else {
					endExecution(this.selectedWorkplan).then((result) => {
						this.executionFinish = result
					})
				}
			}

			function getItemsRequiredList (header) {
				itemList = []

				return WorkPlanSrv.getItemRequiredExecution.getList(header).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						var activities = []

						for (var i in dataReturn.assignatures) {
							for (var j in dataReturn.activities) {
								if (dataReturn.assignatures[i].id_assignature === dataReturn.activities[j].id_assignature) {
									activities.push(dataReturn.activities[j])
								}
							}
							itemList.push({
								assignatureName: dataReturn.assignatures[i].assignatureName,
								assignatureId  : dataReturn.assignatures[i].id_assignature,
								showChilds     : false,
								itemList       : activities,
							})
							activities = []
						}
					} else {
						console.log('Comunications problem with the server')
					}
				}, function (data) {
					console.log(data)
				})
			}

			function validateSubmodules () {
				let validateSubmodules = {
					teaching          : false,
					academicManagement: false,
				}
				let submodule = JSON.parse($cookies.get('subModuleId'))

				for (var i in submodule) {
					if (submodule[i].submoduleId === GlobalConfig.modules.teaching) {
						validateSubmodules.teaching = true
					}

					if (submodule[i].submoduleId === GlobalConfig.modules.academicManagement) {
						validateSubmodules.academicManagement = true
					}
				}

				return validateSubmodules
			}

			function validateItems (submodule) {
				let showModal = false

				if (submodule.teaching) {
					if (itemList.length > 0) { showModal = true }
				}

				return showModal
			}

			function endExecution (wpId) {
				let header = {
					teacherId : user.teacherId,
					workplanId: wpId,
					id        : user.id,
				}

				let submodules = validateSubmodules()

				if (submodules.teaching) {
					return getItemsRequiredList(header).then((promise) => {
						if (validateItems(submodules)) {
							showModalItemRequiredEndPlanning()

							return 0
						} else {
							return getActNotExecutionByTeacher(wpId).then((response) => {
								if (response.activitiesNotEjecution.length > 0) {
									Requests.showModalItemRequiredEndExecution(WorkPlanModalSrv, response.activitiesNotEjecution)
								} else {
									return getSummanyProgress(header.teacherId).then((response) => {
										if (response.isControlHoursActive && (response.isMinHoursExecuted || response.isMaxHoursExecuted)) {
											showModalHoursParametrization(header, response)
										} else {
											WorkPlanModalSrv.setVariable(setEndExecutionHeader(header, response))
											WorkPlanModalSrv.endPlanning().then((result) => {})
										}
									})
								}
							})
						}
					})
				} else {
					return getSummanyProgress(header.teacherId).then((response) => {
						if (response.isControlHoursActive && (response.isMinHoursExecuted || response.isMaxHoursExecuted)) {
							showModalHoursParametrization(header, response)
						} else {
							WorkPlanModalSrv.setVariable(setEndExecutionHeader(header, response))
							WorkPlanModalSrv.endPlanning().then((result) => {})
						}
					})
				}
			}

			function showModalHoursParametrization (header, response) {
				$mdDialog.show({
					controller: [ '$scope', '$mdDialog', function showModalHoursParametrization ($scope, $mdDialog) {
						$scope.data = response
						$scope.close = function () {
							$mdDialog.hide()
							WorkPlanModalSrv.setVariable(setEndExecutionHeader(header, response))
						}
					} ],
					template           : require('../workplan/partials/modals/hoursParametrizationModal.html'),
					clickOutsideToClose: false,
				})
			}

			function showModalItemRequiredEndPlanning () {
				let header = {
					itemAssignatures: itemList,
				}

				WorkPlanModalSrv.setVariable(header)
				WorkPlanModalSrv.itemRequiredExecution()
			}

			function getActivitiesNotExecutionByTeacher (wpId) {
				let post = {
					teacherId : user.teacherId,
					workplanId: wpId,
				}

				return ReviewSrv.getActivitiesNotExecutionByTeacher.get(post).$promise.then((dataReturn) => {
					return dataReturn.status ? dataReturn.activitiesNotEjecution : 0
				})
			}

			function getActNotExecutionByTeacher (wpId) {
				let post = {
					teacherId : user.teacherId,
					workplanId: wpId,
				}

				return ReviewSrv.getActNotExecutionByTeacher.get(post).$promise.then((dataReturn) => {
					return dataReturn
				})
			}

			function showModalActivitiesNotExecution () {
				$mdDialog.show({
					controller: [ '$scope', '$mdDialog', function showModalActivitiesNotExecution ($scope, $mdDialog) {
						$scope.close = function () {
							$mdDialog.hide()
						}
					} ],
					template           : require('../workplan/partials/modals/activitiesNotExecutionModal.html'),
					clickOutsideToClose: false,
				})
			}

			function getRecordTeacher (post, aux) {
				aux.downloadRequests++
				aux.disableDownload = true

				return WorkPlanSrv.getRecordTeacher.get(post).$promise.then(dataReturn => {
					if (dataReturn.status) {
						aux.recordTeacher = dataReturn.data[0]

						if (aux.downloadRequests === 1) {
							aux.downloadRequests--
							aux.disableDownload = false
						} else {
							aux.downloadRequests--
						}
					} else {
						console.log('Comunications problem with the server')
					}
				})
			}

			function hiddenTable () {
				if (this.class === this.iconClasses[0]) {
					this.class = this.iconClasses[1]
					this.showTable = true
				} else {
					this.class = this.iconClasses[0]
					this.showTable = false
				}
			}

			function showModalReactivateWorkplan(obj) {
				$mdDialog.show({
					controller: [ '$scope', '$mdDialog', function showModalReactivateWorkplan($scope, $mdDialog) {
						$scope.reactivate = function(isNew) {
							showModalConfirm(isNew, obj)
						}
						$scope.close = function() {
							$mdDialog.hide()
							$state.go('fullscreen.welcomeHome')
						}
					} ],
					template           : require('../workplan/generalInformation/consultInformation/reactivateWorkplanModal.html'),
					clickOutsideToClose: false,
				})
			}

			function showModalConfirm(isNew, obj) {
				$mdDialog.show({
					controller: [ '$scope', '$mdDialog', function showModalConfirm($scope, $mdDialog) {
						$scope.continue = function() {
							let post = {
								teacherId : user.teacherId,
								workplanId: user.workplanId,
								isNew     : isNew,
							}

							return WorkPlanSrv.setPlanningWorkplanByTeacher.set(post).$promise.then(function (dataReturn) {
								if (dataReturn.status) {
									$cookies.put('isReproved', 0)
									$mdDialog.hide()
									$state.reload()
									getData(obj)
								}
							}, function (data) {
								$mdDialog.hide()
							})
						}
						$scope.close = function() {
							$mdDialog.hide()
							$state.go('fullscreen.welcomeHome')
						}
					} ],
					template           : require('../workplan/generalInformation/consultInformation/confirmReactivateWorkplanModal.html'),
					clickOutsideToClose: false,
				})
			}
		} ],
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/history.js